<template>
  <div>
    <h1>Create Worklog</h1>
    <form class="mt-5" v-on:submit.prevent="createWorklog">
      <div class="form-group" v-if="getUser.type != 'customer'">
        <p>
          <label for="dropdownList"> Select Customer</label>
        </p>
        <dropdownlist
          id="dropdownList"
          :data-items="getClient"
          :text-field="'companyName'"
          :data-item-key="'companyRegistrationId'"
          :filterable="true"
          @filterchange="filterChange"
          @change="onChange"
          :default-item="defaultItem"
        ></dropdownlist>
      </div>
      <div class="form-group" v-else>
        <h3 v-if="getCompanyData">{{ getCompanyData.companyName }}</h3>
      </div>
      <!-- <div
        class="form-group"
        v-if="selectCustomer.users && selectCustomer.users.length > 0"
      >
        <p>
          <label for="dropdownList1">Contact</label>
        </p>
        <dropdownlist
          id="dropdownList1"
          :data-items="selectCustomer.users"
          :text-field="'name'"
          :data-item-key="'phoneNumber'"
          :filterable="false"
          @filterchange="userFilterChange"
          @change="onChangeUser"
          :default-item="defaultItem1"
        ></dropdownlist>
      </div> -->
      <div class="form-group">
        <label for="exampleFormControlInput1">Contact</label>
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="Ime prezime (onaj ko je prijavio problem)"
          v-model="contact"
          :disabled="getUser && getUser.type === 'customer'"
        />
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">Broj telefona</label>
        <input
          type="text"
          class="form-control"
          id="exampleFormControlInput1"
          placeholder="06x/xxx-xxx"
          v-model="phoneNumber"
        />
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1">Vrsta</label>
        <select
          class="form-control"
          id="exampleFormControlSelect1"
          v-model="typeOfProblem"
        >
          <option
            v-for="problem in getOptions.knownProblems"
            :key="problem.index"
            >{{ problem }}</option
          >
        </select>
      </div>
      <div class="form-group">
        Promijeni datum otvaranja naloga
        <input
          type="checkbox"
          name=""
          id=""
          v-model="changeDate"
          placeholder="Test"
        />
        <date-time-picker
          v-model="selectedDate"
          v-if="changeDate"
        ></date-time-picker>
      </div>
      <div class="form-group">
        <label for="exampleFormControlTextarea1">Detaljan opis</label>
        <textarea
          class="form-control"
          id="exampleFormControlTextarea1"
          rows="3"
          v-model="description"
        ></textarea>
      </div>
      <button class="btn btn-success">Kreiraj nalog</button>
    </form>
  </div>
</template>
<script>
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import DateTimePicker from "@/components/Common/DateTimePicker";

const textField = "companyName";
const keyField = "companyRegistrationId";
const textField1 = "name";
const keyField1 = "phoneNumber";
const defaultItem = { [textField]: "Select customer...", [keyField]: null };
const defaultItem1 = { [textField1]: "Select user...", [keyField1]: null };
const emptyItem = { [textField]: "loading ..." };
/*eslint-disable */

export default {
  components: {
    dropdownlist: DropDownList,
    "date-time-picker": DateTimePicker
  },
  created() {
    if (this.getCompanyData && this.getUser.type === "customer") {
      this.selectCustomer = this.getCompanyData;
      this.contact = this.getUser.name;
      this.additionalOptions = {
        redirect: "/helpdesk",
        sendEmail: true
      };
    }
  },
  data() {
    return {
      items: [],
      selectCustomer: {},
      defaultItem: defaultItem,
      emptyItem: emptyItem,
      contact: "",
      phoneNumber: "",
      typeOfProblem: "",
      description: "",
      status: "New",
      openedTicketDate: "",
      safeClients: {},
      defaultItem1: defaultItem1,
      additionalOptions: {},
      selectedDate: new Date(),
      changeDate: false
    };
  },
  methods: {
    filterChange(event) {
      var array = this.getClient.splice();
      array = this.filterData(event.filter);
      this.$store.commit("setClients", array);
    },
    filterData(filter) {
      if (filter.value.length <= 1)
        this.$store.commit("setClients", this.getSafeClients);
      const data = this.getClient.slice();
      return filterBy(data, filter);
    },

    onChange(event) {
      const value = event.value;
      if (value && value[textField] === emptyItem[textField]) {
        return;
      }
      this.selectCustomer = value;
      this.phoneNumber = value.phoneNumber;
      this.$store.commit("setClients", this.getSafeClients);
    },
    userFilterChange() {
      // var array = this.selectCustomer.users.splice();
      // array = this.filterData(event.filter);
    },
    filterUserData(filter) {
      // if (filter.value.length <= 1)
      // this.$store.commit("setClients", this.getSafeClients);
      const data = this.selectCustomer.users.slice();
      return filterBy(data, filter);
    },

    onChangeUser(event) {
      const value = event.value;
      if (value && value[textField] === emptyItem[textField]) {
        return;
      }
      this.contact = value;
      this.phoneNumber = value.phoneNumber;
    },
    createWorklog() {
      this.openedTicketDate = this.changeDate
        ? new Date(this.selectedDate).getTime()
        : Date.now();

      const newWorklog = {
        customer: this.selectCustomer,
        contactPerson:
          typeof this.contact === "object" ? this.contact.name : this.contact,
        phoneNumber: this.phoneNumber,
        typeOfProblem: this.typeOfProblem,
        problemDescription: this.description,
        status: this.status,
        dateTicketWasOpened: this.openedTicketDate,
        additionalOptions: this.additionalOptions
      };
      // console.log(newWorklog);
      this.$store.dispatch("addNewWorklog", newWorklog);
    }
  },
  computed: {
    getClient() {
      return this.$store.getters.getClients;
    },
    getSafeClients() {
      return this.$store.getters.getSafeClients;
    },
    getOptions() {
      return this.$store.getters.getOptions;
    },
    getUser() {
      return this.$store.getters.user;
    },
    getCompanyData() {
      return this.$store.getters.getCompanyData;
    }
  }
};
</script>
<style></style>
